<template>
  <div>
    <div class="layout">
      <div class="platform">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="tit">{{ $t("extension.head1") }}</p>
              <div class="download">
                <div class="d-left">
                  <a
                    class="chrome-extension-down"
                    href="https://static.sdchain.io/files/crx/SDWalletPay.zip"
                    target="view_blank"
                  >
                    <span>{{ $t("extension.head2") }}</span>
                    <span class="version" v-if="chromeExtensionVersion"
                      >V{{ chromeExtensionVersion }}</span
                    >
                  </a>
                </div>
              </div>
            </div>
            <div class="right">
              <img src="../assets/images/chromeExtension/chrome-part.png" alt />
            </div>
          </div>
        </div>
        <div class="part-2" id="part-2">
          <div class="main">
            <!-- <div :class="['doc-nav', fixedNav ? 'fixed-nav' : '']">
              <ul class="nav-list">
                <li
                  :class="{ active: item.id === docNavActive }"
                  v-for="item in docNavList"
                  :key="item.id"
                  @click="scrollElem(item.id)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div> -->
            <div class="doc-content">
              <div class="par" ref="par1" id="par1">
                <h3 class="par-title">
                  {{ $t("extension.title1") }}
                </h3>
                <div class="par-content">
                  <p>
                    {{ $t("extension.text1") }} “<a
                      href="https://static.sdchain.io/files/crx/SDWalletPay.zip"
                      target="view_blank"
                      >{{ $t("extension.link1") }}</a
                    >”{{ $t("extension.text2") }}。
                  </p>
                  <p>2.{{ $t("extension.text3") }}。</p>
                  <img src="../assets/images/chromeExtension/1.png" alt="" />
                  <p>
                    3. {{ $t("extension.text4") }}，<a
                      href="https://www.google.cn/chrome/"
                      target="view_blank"
                      >https://www.google.cn/chrome/</a
                    >。{{ $t("extension.text5") }}。
                  </p>
                  <p>4.{{ $t("extension.text6") }}。</p>
                  <img src="../assets/images/chromeExtension/2.png" alt="" />
                  <p>5.{{ $t("extension.text7") }} 。</p>
                  <img src="../assets/images/chromeExtension/3.png" alt="" />
                  <p>6.{{ $t("extension.text8") }}。</p>
                  <img src="../assets/images/chromeExtension/4.png" alt="" />
                  <p>7.{{ $t("extension.text9") }}。</p>
                  <img src="../assets/images/chromeExtension/5.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "iview";
import axios from "axios";
export default {
  name: "service",
  components: {
    Button,
  },
  data() {
    return {
      cn: false,
      en: false,
      chromeExtensionVersion: '1.0.0', //chrome扩展程序版本
      docNavActive: 1, //文档导航高亮
      fixedNav: false, //导航固定
      docNavList: [
        //文档导航
        {
          id: 1,
          name: "插件的安装",
        },
        {
          id: 2,
          name: "插件的升级",
        },
        {
          id: 3,
          name: "插件的使用",
        },
        {
          id: 4,
          name: "API的使用",
        },
      ],
    };
  },
  mounted() {
    let that = this;
    // this.init(); //初始化
    // window.addEventListener("scroll", that.handleScroll); //监听页面滚动
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      if (localStorage.Lang == "en") {
        this.en = true;
      } else {
        this.cn = true;
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
    /*初始化页面*/
    init() {
      this.mobile();
      // this.getExtensionsConfig(); //获取chrome扩展程序的版本信息
      if (this.$route.query && this.$route.query.doc) {
        // this.scrollElem(Number(this.$route.query.doc)); //跳转到相应段落
        setTimeout(() => {
          this.scrollElem(Number(this.$route.query.doc)); //跳转到相应段落
        }, 300);
      }
    },
    /*获取chrome扩展程序的版本信息*/
    getExtensionsConfig() {
      let url =
        process.env.NODE_ENV == "development"
          ? `/api/extensionsConfig.json?time=${new Date().getTime()}`
          : `/extensionsConfig.json?time=${new Date().getTime()}`;
      axios
        .get(url)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.version)
              this.chromeExtensionVersion = res.data.version;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get("/hw/api/admin/noauth/showError")
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /*监听页面滚动*/
    handleScroll() {
      let oDoc = document.querySelector("#part-2");
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= oDoc.offsetTop) {
        //超过文档位置固定导航
        this.fixedNav = true;
      } else {
        this.fixedNav = false;
      }
      this.docNavList.forEach((item, i) => {
        let refId = `par${item.id}`;
        let elemItem = document.querySelector(`#${refId}`);
        if (scrollTop >= elemItem.offsetTop) {
          this.docNavActive = item.id; //当前点击按钮高亮
        }
      });
    },
    /*滚动到相应段落*/
    scrollElem(key) {
      let findIndex = this.docNavList.find((item) => Number(key) === item.id);
      key = /^\d+$/.test(key) && findIndex ? key : 1;
      this.docNavActive = key; //当前点击按钮高亮
      this.$nextTick(() => {
        let elemId = this.$refs[`par${key}`]; //通过段落id获取段落
        document.documentElement.scrollTop = elemId.offsetTop;
        document.body.scrollTop = elemId.offsetTop; // chrome
      });
    },
  },
  destroyed() {
    //离开页面，销毁监听页面滚动事件
    window.removeEventListener("scroll", this.handleScroll, false);
  },
};
</script>
<style lang="less" scoped>
@import url("../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.platform {
  .part-1 {
    background: linear-gradient(
      81deg,
      rgba(24, 73, 200, 1),
      rgba(47, 114, 224, 1)
    );
    height: 599px;
    .main {
      *zoom: 1;
      &:after {
        display: block;
        clear: both;
        content: "";
        visibility: hidden;
        height: 0;
      }
    }
    .left {
      width: 50%;
      float: left;
      padding-right: 20px;
      padding-left: 6%;
      vertical-align: middle;
      .tit {
        display: block;
        margin-top: 250px;
        text-align: left;
        font-size: 66px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      .text {
        width: 522px;
        line-height: 30px;
        font-size: 18px;
        color: rgba(255, 255, 255, 1);
      }
      .download {
        display: flex;
        justify-content: flex-start;
        .d-left {
          .chrome-extension-down {
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 23px;
            padding: 0 20px;
            margin-top: 20px;
            cursor: pointer;
            span {
              display: inline-block;
              color: #fff;
              font-size: 16px;
            }
            .version {
              padding-left: 15px;
              margin-left: 15px;
              position: relative;
              &::before {
                content: "";
                width: 1px;
                height: 70%;
                background: #ffffff;
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
              }
            }
          }
        }
        .d-right {
          text-align: center;
          margin-left: 55px;
          padding-top: 28px;
          img {
            width: 100px;
          }
          p {
            color: #fff;
            font-size: 16px;
          }
        }
      }
    }
    .right {
      width: 50%;
      float: left;
      text-align: left;
      vertical-align: middle;
      margin-top: 150px;
      padding-left: 20px;
      img {
        width: 472px;
        height: 399px;
      }
    }
  }
  .part-2 {
    .main {
      display: flex;
      justify-content: center;
      *zoom: 1;
      &:after {
        display: block;
        clear: both;
        content: "";
        visibility: hidden;
        height: 0;
      }
      height: 100%;
      padding: 40px 0;
      // display: flex;
      color: #666666;
      .doc-nav {
        display: inline-block;
        width: 140px;
        text-align: center;
        &.fixed-nav {
          position: fixed;
          top: 20px;
        }
        li {
          width: 100%;
          font-size: 14px;
          padding: 10px 20px;
          margin: 5px 0;
          cursor: pointer;
          &:hover,
          &.active {
            border-radius: 3px;
            color: #ffffff;
            background: #2a93ff;
          }
        }
      }
      .doc-content {
        display: inline-block;
        max-width: calc(1140px - 140px);
        min-width: calc(1024px - 140px);
        line-height: 2;
        padding: 0 40px;
        // float: right;
        box-sizing: border-box;
        .par-title {
          color: #333333;
          margin-bottom: 5px;
        }
        p {
          // margin-bottom: 10px;
          .tips {
            font-weight: bold;
          }
        }
        img {
          max-width: 800px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
